<div id="content">
 <!-- <a href="http://paie-push.fr"><img alt="Paie Push logo" class="logo2" src="../../assets/logo2.png"/></a><br/> -->
 Copyright © DEVARCHI 2020 - <a routerLink='/conditions'>CGV - CGU - RGPD</a>
</div>
